module.exports = __webpack_public_path__ + "static/media/personalClass.e5542aff.svg";